export default {
  title: 'Welcome, {{ name }}',
  installation_progress: {
    description:
      'Your my<b>En</b>OS<sup>TM</sup> customer portal provides you with all the important information about your charging station and your contracts.',
    text: 'Under Charger section, you can see details about the charger model installed at your location. Here you can change the name of the charging station. <br/><br/> Under Documents, you will find all relevant documents, such as the general terms and conditions, operating instructions for your charger, and your one-time and, if applicable, monthly energy and service bills. In the Customer Service section, you will find all the important contact information we need to quickly assist you with your request. <br/><br/> In your Profile Settings, you can view your personal data, change your password, edit your stored payment method, and upload and update your electricity tariff for home charging reimbursement.',
    status_date: {
      completed: 'Completed on {{date}}',
      planned: 'Planned for {{date}}',
      not_planned: 'Not yet planned',
    },
    event_type: {
      order_completed_contacted: 'Order confirmed',
      order_completed_will_contact:
        'Thank you for confirming your order. We will be in touch with you soon.',
      order_completed: 'Order completed',
      previsit: 'Pre-visit successfully completed on ',
      quote: 'quote acceptance',
      installation: 'Installation',
      quote_accepted: 'offer accepted',
    },
    category: {
      order: 'order',
      installation_preparation: 'Installation preparation',
      installation: 'Installation',
    },
  },
  add_payment: {
    title: 'Payment details',
    text: 'Add your payment method for your monthly billing',
    button: 'Payment Details',
    notificationText:
      'Please deposit a payment method for your monthly bill. <span class="whitespace-nowrap"><a href="{{path}}">Deposit now</a><img class="lang-switcher__arrow-icon" src="{{icon}}" /></span>',
  },
  upload_photos: {
    title: 'Upload photos',
    text: 'Our customer service team would like you to provide some photos for your installer to finalise their quote:',
    button: 'Add pictures',
  },
  get_app: {
    title: 'Get our app',
    text: 'With the Univers Charge app, you can find public charging points and available chargers at your company location, and start, monitor, and stop your charging process—from anywhere, anytime.',
    button: 'Download the app',
  },
  business_documents: {
    title: 'Documents',
    text: 'View your available documents',
  },
  news: {
    label: 'NEWS',
  },
  installation_completed: {
    text: 'We hope you are happy with Charging Solutions by Univers. Enjoy our service!',
  },
}
